import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import architectureMd from "../engine/ARCHITECTURE.md?raw";

export default function DevArchitecture() {
  useEffect(() => {
    document.title = "Reasoning Platform Architecture — Retail Ranker";
  }, []);
  return (
    <main className="mx-auto max-w-3xl px-6 py-12">
      <div className="prose prose-slate dark:prose-invert max-w-none prose-pre:bg-muted prose-pre:text-foreground prose-code:before:content-none prose-code:after:content-none">
        <ReactMarkdown>{architectureMd}</ReactMarkdown>
      </div>
    </main>
  );
}